import ClearIcon from '@mui/icons-material/Close'
import {
  FormControl,
  FormLabel,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from '@mui/material'
import { connectField, filterDOMProps } from 'uniforms'
import { Markdown } from '../../Markdown'
import { useCiboAutoForm } from './CiboAutoFormContext'
import { ValidationMessages } from './ValidationMessages'

interface ClearableTextFieldProps {
  value: number | undefined | null
  onChange: (value: string | undefined) => void
  label?: string
  disabled?: boolean
  error?: any
  helperText?: string
  required?: boolean
  name: string
  placeholder?: string
  [key: string]: any // uniforms injects many props
}

function ClearableTextField({
  value,
  onChange,
  label,
  error,
  helperText,
  disabled,
  required,
  placeholder,
  description,
  ...props
}: ClearableTextFieldProps) {
  const { touch } = useCiboAutoForm()

  return (
    <FormControl fullWidth {...filterDOMProps(props)} required={required} disabled={disabled}>
      {label && <FormLabel component="legend">{label}</FormLabel>}

      <TextField
        {...filterDOMProps(props)}
        value={value ?? ''}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
        helperText={helperText}
        onChange={e => {
          const v = e.target.value
          // Empty string → undefined (Uniforms best practice)
          if (v === '') onChange(undefined)
          else onChange(v)

          touch(props.name)
        }}
        onBlur={() => touch(props.name)}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title={'Clear value'}>
                  <IconButton
                    size="small"
                    onClick={() => onChange(undefined)}
                    disabled={disabled || !value}
                    edge="end"
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          },
        }}
        fullWidth
      />

      <ValidationMessages fieldName={props.name} error={error} />

      {!!description && <Markdown typographyProps={{ variant: 'caption' }}>{description}</Markdown>}
    </FormControl>
  )
}

export default connectField(ClearableTextField)
